import { render, staticRenderFns } from "./tags_mobile.vue?vue&type=template&id=ddd21912&"
import script from "./tags_mobile.vue?vue&type=script&lang=js&"
export * from "./tags_mobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports